import { render, staticRenderFns } from "./reserve.vue?vue&type=template&id=645279a3&scoped=true"
import script from "./reserve.vue?vue&type=script&lang=js"
export * from "./reserve.vue?vue&type=script&lang=js"
import style0 from "./reserve.vue?vue&type=style&index=0&id=645279a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645279a3",
  null
  
)

export default component.exports